import { render, staticRenderFns } from "./KisDefect.vue?vue&type=template&id=1f26d2cd"
import script from "./KisDefect.js?vue&type=script&lang=js&external"
export * from "./KisDefect.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports